export default __webpack_public_path__ + "static/media/new-play-store.67dce054.svg";